module.exports = __webpack_public_path__ + "static/hiw_tag-38607f8fc0e45c376bd691272f0d97c3.svg";